/** Design-token bridge for the workflow editor host: maps DesignSystem tokens onto the host's `--local-workflow-editor-*` variables. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

/** Style element id; mounting twice replaces rather than duplicates. */
export const workflowEditorHostStyleId = 'wb-v2-surface-workflow-editor-host-theme';

/** The host's local variables, mounted once by the host constructor. */
export const workflowEditorHostBridgeStyles = {
  'wb-surface-workflow-editor-host': {
    '--local-workflow-editor-background': tokens.color.background.primary,
    '--local-workflow-editor-canvas': tokens.color.background.secondary,
    '--local-workflow-editor-text': tokens.color.text.primary,
    '--local-workflow-editor-muted': tokens.color.text.tertiary,
    '--local-workflow-editor-quaternary': tokens.color.text.quaternary,
    '--local-workflow-editor-border': tokens.color.border.secondary,
    '--local-workflow-editor-border-strong': tokens.color.border.primary,
    '--local-workflow-editor-hover': tokens.color.background.primaryHover,
    '--local-workflow-editor-padding': tokens.spacing.lg,
    '--local-workflow-editor-gap': tokens.spacing.md,
    '--local-workflow-editor-title-size': tokens.font.size.textLg,
    '--local-workflow-editor-text-size': tokens.font.size.textSm,
    '--local-workflow-editor-small-size': tokens.font.size.textXs,
    '--local-workflow-editor-weight': tokens.font.weight.semibold,
    '--local-workflow-editor-radius': tokens.radius.md,
    '--local-workflow-editor-sheet-radius': tokens.radius.lg,
    '--local-workflow-editor-drawer-width': '380px',
    '--local-workflow-editor-rail-overlay-shadow': tokens.shadow.lg,
    '--local-workflow-editor-sheet-shadow': tokens.shadow.xl,
    '--local-workflow-editor-dirty-background': tokens.color.background.warningPrimary,
    '--local-workflow-editor-dirty-text': tokens.color.text.warningPrimary,
    '--local-workflow-editor-error-background': tokens.color.background.errorPrimary,
    '--local-workflow-editor-error-text': tokens.color.text.errorPrimary,
  },
};
